// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ebf3582fc1f760b6569f87048dee3c9ce98551c2/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};